import React from 'react';
import { Nav } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * Componente de tabs dinâmicas para navegação entre categorias
 * Reutilizável para nível 1 (tipos) e nível 2 (categorias)
 */
export default function DicionarioTabs({
  items = [],
  activeKey = '',
  onSelect,
  size = 'normal', // 'normal' | 'small'
  wrap = true,
}) {
  if (!items || items.length === 0) {
    return null;
  }

  const isSmall = size === 'small';

  return (
    <Nav
      variant="tabs"
      activeKey={activeKey}
      onSelect={onSelect}
      style={{
        flexWrap: wrap ? 'wrap' : 'nowrap',
        overflowX: wrap ? 'visible' : 'auto',
        backgroundColor: '#f0f0f0',
        padding: isSmall ? '2px 0' : '5px 0',
      }}
    >
      {items.map((item, index) => (
        <Nav.Item
          key={item.id || `tab-${index}`}
          style={{ margin: isSmall ? '1px' : '2px' }}
        >
          <Nav.Link
            eventKey={item.id}
            style={{
              padding: isSmall ? '4px 8px' : '8px 12px',
              fontSize: isSmall ? '0.75rem' : '0.85rem',
              fontWeight: activeKey === item.id ? 'bold' : 'normal',
              backgroundColor:
                activeKey === item.id
                  ? '#008080'
                  : '#e0e0e0',
              color: activeKey === item.id ? 'white' : '#333',
              borderTop:
                activeKey === item.id
                  ? '1px solid #008080'
                  : '1px solid #ccc',
              borderBottom: 'none',
              borderRadius: '4px 4px 0 0',
              whiteSpace: 'nowrap',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={e => {
              if (activeKey !== item.id) {
                e.target.style.backgroundColor = '#c0c0c0';
              }
            }}
            onMouseLeave={e => {
              if (activeKey !== item.id) {
                e.target.style.backgroundColor =
                  '#e0e0e0';
              }
            }}
          >
            {item.nome === 'REGIAO' ? 'Regiões - C Seg' : (item.nome || item.id)}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
}

DicionarioTabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      nome: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  activeKey: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['tabs']),
  size: PropTypes.oneOf(['normal', 'small']),
  wrap: PropTypes.bool,
};
